import Accordion from '../Accordion';
import { useStore } from '../../store/useStore';
import { User, Mail } from 'lucide-react';

export default function ProfileSection() {
  const { user } = useStore();

  return (
    <Accordion title="Perfil" defaultOpen={false}>
      <div className="space-y-4">
        <div className="flex items-start space-x-3">
          <div className="p-2 bg-navy-100 dark:bg-navy-800 rounded-lg">
            <User className="h-5 w-5 text-navy-500 dark:text-navy-400" />
          </div>
          <div>
            <label className="block text-sm font-medium text-navy-500 dark:text-navy-400">
              Nome
            </label>
            <p className="mt-1 text-navy-900 dark:text-navy-100 font-medium">{user?.name}</p>
          </div>
        </div>

        <div className="flex items-start space-x-3">
          <div className="p-2 bg-navy-100 dark:bg-navy-800 rounded-lg">
            <Mail className="h-5 w-5 text-navy-500 dark:text-navy-400" />
          </div>
          <div>
            <label className="block text-sm font-medium text-navy-500 dark:text-navy-400">
              Email
            </label>
            <p className="mt-1 text-navy-900 dark:text-navy-100 font-medium">{user?.email}</p>
          </div>
        </div>
      </div>
    </Accordion>
  );
}
